export default __webpack_public_path__ + "static/media/pattern-16.26e5c843.png";